import React from 'react';
import styled from 'styled-components';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import { link1, link2, link3, link4, link5 } from './links';
import openInNewTab from '../../../../../../utils/openInNewTab';

const VIDEOS = [
  { id: 1, title: 'Introduction', url: link1 },
  { id: 2, title: 'How to Access your Permits', url: link2 },
  { id: 3, title: 'How to Schedule Inspections', url: link3 },
  { id: 4, title: 'How to Pay Invoices', url: link4 },
  { id: 5, title: 'How to Upload Documents', url: link5 },
];

const Toturial = () => (
  <List>
    {VIDEOS.map(video => (
      <Tile
        key={video.id}
        type="button"
        onClick={() => openInNewTab(video.url)}
      >
        <Number>{String(video.id).padStart(2, '0')}</Number>
        <Body>
          <Eyebrow>Video {video.id}</Eyebrow>
          <Title>{video.title}</Title>
        </Body>
        <PlayIcon>
          <PlayCircleOutlineIcon />
        </PlayIcon>
      </Tile>
    ))}
  </List>
);

export default Toturial;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Tile = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 14px 16px;
  background: var(--neutral-0);
  border: 1px solid var(--border);
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease,
    box-shadow 0.15s ease, transform 0.15s ease;

  &:hover {
    background: var(--primary-50);
    border-color: var(--primary-600);
    box-shadow: var(--shadow-xs);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
    border-color: var(--primary-600);
  }

  &:active {
    transform: translateY(1px);
  }
`;

const Number = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: var(--primary-50);
  color: var(--primary-700);
  font-weight: 700;
  font-size: 0.875rem;
  letter-spacing: 0.02em;

  ${Tile}:hover & {
    background: var(--primary-600);
    color: var(--neutral-0);
  }
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

const Eyebrow = styled.span`
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--neutral-500);
`;

const Title = styled.span`
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--mainText);
`;

const PlayIcon = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--neutral-400);
  transition: color 0.15s ease, transform 0.15s ease;

  svg {
    width: 22px;
    height: 22px;
  }

  ${Tile}:hover & {
    color: var(--primary-600);
    transform: translateX(2px);
  }
`;
